import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";

const Logo = ({ at, width, className, textClass, ...rest }) => {
  return (
    <Link
      to="/"
      className={classNames(
        "text-decoration-none",
        { "navbar-brand text-left": at === "navbar-vertical" },
        { "navbar-brand text-left": at === "navbar-top" }
      )}
      {...rest}
    >
      <div
        className={classNames(
          "d-flex",
          {
            "align-items-center py-3": at === "navbar-vertical",
            "align-items-center": at === "navbar-top",
            "flex-center fw-bolder fs-5 mb-4": at === "auth",
          },
          className
        )}
      >
        <svg
          className={"logo_image"}
          width="130"
          height="34"
          viewBox="0 0 130 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.683 0C19.9826 0 23.2081 0.978441 25.9516 2.81159C28.6951 4.64474 30.8334 7.25027 32.0961 10.2987C33.3588 13.3471 33.6892 16.7015 33.0454 19.9377C32.4017 23.1739 30.8128 26.1465 28.4797 28.4797C26.1465 30.8128 23.1739 32.4017 19.9377 33.0454C16.7015 33.6892 13.3471 33.3588 10.2987 32.0961C7.25027 30.8334 4.64474 28.6951 2.81159 25.9516C0.978441 23.2081 0 19.9826 0 16.683C0 12.2584 1.75767 8.01501 4.88634 4.88634C8.01501 1.75767 12.2584 0 16.683 0V0Z"
            fill="#191919"
          />
          <g filter="url(#filter0_d_13_160)">
            <path
              d="M9.56807 25.883L13.7981 18.556H5.26807V15.168H13.8021L9.56807 7.84097L12.5051 6.14697L18.6831 16.852L18.6641 16.863H18.6711L12.5051 27.577L9.56807 25.883Z"
              fill="#BAECFF"
            />
          </g>
          <path
            d="M18.396 23.6899L20.488 20.6769L24.404 26.1559L21.472 27.8479L18.396 23.6899ZM21.977 18.8109V15.4229H28.51V18.8109H21.977ZM18.304 10.6149L21.566 6.14795L24.504 7.84095L20.504 13.5879L18.304 10.6149Z"
            fill="#FFB0F7"
          />
          <path
            className={"logo_text"}
            d="M40.4922 23.1692C42.2146 24.0939 44.14 24.5752 46.0949 24.5699C50.6471 24.5699 52.5438 22.4688 52.5438 19.7842C52.5438 16.8953 50.3261 15.9032 47.7874 15.1737C46.1532 14.7068 44.8401 14.5317 44.8401 13.6855C44.8401 13.0727 45.6864 12.81 46.6785 12.81C48.3145 12.797 49.9217 13.2417 51.3182 14.094V10.3005C49.8883 9.4295 48.2352 8.99486 46.5618 9.0499C43.5853 9.0499 40.784 10.6257 40.784 13.6354C40.7625 14.4813 40.9959 15.314 41.4538 16.0254C41.9118 16.7369 42.5731 17.2942 43.3519 17.6249C45.5404 18.7045 48.371 18.8755 48.371 19.8718C48.371 20.5721 47.5247 20.8639 46.2116 20.8639C44.1677 20.9015 42.1648 20.2883 40.4922 19.1131V23.1692ZM53.0399 16.9537C53.0399 21.5642 56.2789 24.5699 61.0354 24.5699C62.949 24.6934 64.8543 24.2247 66.4922 23.2275V19.4341C64.9457 20.4501 63.1172 20.9506 61.2688 20.8639C58.9636 20.8639 57.4754 19.755 57.3878 18.0042H68.1847C68.2403 17.5296 68.2695 17.0522 68.2722 16.5743C68.3052 15.5883 68.1352 14.6059 67.7729 13.6882C67.4106 12.7706 66.8637 11.937 66.1661 11.2394C65.4684 10.5418 64.6349 9.99484 63.7172 9.63255C62.7995 9.27026 61.8172 9.10032 60.8311 9.13327C59.8028 9.0754 58.7736 9.23336 57.81 9.597C56.8463 9.96064 55.9693 10.5219 55.2355 11.2447C54.5017 11.9675 53.9273 12.8359 53.5492 13.794C53.171 14.752 52.9975 15.7787 53.0399 16.8078V16.9537ZM57.417 15.1737C57.5045 13.8314 59.0219 12.7517 60.8311 12.7517C62.5528 12.7517 63.8951 13.8605 63.8951 15.1737H57.417ZM69.527 24.1905H73.8749V3.85156H69.527V24.1905ZM75.9176 24.1905H80.2655V3.85156H75.9176V24.1905ZM82.304 24.1905H86.6519V22.2646C87.0604 23.5152 88.7821 24.4531 91.029 24.4531C92.0129 24.4483 92.9858 24.2455 93.8898 23.857C94.7938 23.4684 95.6104 22.902 96.291 22.1915C96.9716 21.4809 97.5024 20.6407 97.8517 19.7208C98.2009 18.8009 98.3616 17.8202 98.3242 16.837C98.3592 15.8544 98.1968 14.8747 97.8466 13.9559C97.4964 13.0371 96.9656 12.1979 96.2854 11.4878C95.6053 10.7778 94.7897 10.2113 93.8868 9.82192C92.984 9.43253 92.0122 9.22813 91.029 9.22081C88.7821 9.22081 87.0604 10.1254 86.6519 11.4094V3.85156H82.304V24.1905ZM86.3893 16.837C86.3973 16.3412 86.5039 15.852 86.7027 15.3979C86.9016 14.9437 87.1888 14.5336 87.5476 14.1914C87.9065 13.8493 88.3297 13.5819 88.7929 13.4049C89.256 13.2278 89.7497 13.1447 90.2453 13.1602C90.7334 13.1503 91.2185 13.2383 91.6721 13.4189C92.1257 13.5995 92.5385 13.869 92.8862 14.2117C93.2339 14.5544 93.5095 14.9632 93.6967 15.4141C93.8839 15.865 93.979 16.3488 93.9762 16.837C93.979 17.3252 93.8839 17.809 93.6967 18.2598C93.5095 18.7107 93.2339 19.1196 92.8862 19.4622C92.5385 19.8049 92.1257 20.0745 91.6721 20.2551C91.2185 20.4357 90.7334 20.5236 90.2453 20.5137C89.7501 20.5287 89.2568 20.4451 88.7941 20.2678C88.3315 20.0906 87.9087 19.8231 87.5503 19.481C87.1919 19.1389 86.9051 18.729 86.7065 18.2751C86.5079 17.8212 86.4015 17.3324 86.3934 16.837H86.3893ZM103.668 24.4531L101.305 29.8516H105.769L114.436 9.48344H109.913L105.944 19.2923L102.034 9.48761H97.5113L103.668 24.4531ZM113.123 24.1905H117.821L121.118 19.605L124.416 24.1905H129.114L123.54 16.4576L128.589 9.48344H123.861L121.118 13.3645L118.375 9.48344H113.648L118.696 16.4576L113.123 24.1905Z"
            fill="#191919"
          />
          <defs>
            <filter
              id="filter0_d_13_160"
              x="2.26807"
              y="4.14697"
              width="19.415"
              height="27.43"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1.5" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0.122 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_13_160"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_13_160"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(["navbar-vertical", "navbar-top", "auth"]),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string,
};

Logo.defaultProps = { at: "auth", width: 58 };

export default Logo;
